import { Box, Skeleton } from "@chakra-ui/react";
import HeaderTable from "./HeaderTable";
import ItemTable from "./ItemTable";
import FooterTable from "./FooterTable";
import { Empty } from "antd";
import { OrcamentoItem } from "features/orcamento/typings";

interface TableItensCotadosProps {
  data?: OrcamentoItem[];
  isLoading?: boolean;
  onDelete:any
  onEdit: React.Dispatch<React.SetStateAction<number | undefined>>
}

export default function TableItensCotados({
  data,
  isLoading,
  onEdit,
  onDelete
}: TableItensCotadosProps) {
  return (
    <Box>
      <HeaderTable />

      {isLoading ? (
        <>
          <Skeleton w="100%" h="90px" />
          <Skeleton w="100%" h="90px" />
          <Skeleton w="100%" h="90px" />
          <Skeleton w="100%" h="90px" />
        </>
      ) : null}

      {!isLoading && !data?.length ? <Empty description="Sem itens." /> : null}

      {data?.map((item, index) => (
        <ItemTable
          key={item.id}
          item={item}
          onDelete={onDelete}
          indexItem={index}
          onEdit={onEdit}
        />
      ))}

      {data?.length ? <FooterTable total={data?.length} /> : null}
    </Box>
  );
}
